import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as adminAnalyticsActions from "../actions/admin_analytics_actions";
import * as adminAnalyticsTypes from "../types/admin_analytics_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getGroupWiseAccountsCount(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_GROUP_WISE_ACCOUNTS_COUNT, action.payload);
    if (res.status === 200) {
      yield put(adminAnalyticsActions.getGroupWiseAccountsCountSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(adminAnalyticsActions.getGroupWiseAccountsCountError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(adminAnalyticsActions.getGroupWiseAccountsCountError(e));
  }
}

export default function* groupWiseAccountsCountSaga() {
  yield takeLatest(adminAnalyticsTypes.getGroupWiseAccountsCount.GET_GROUP_WISE_ACCOUNTS_COUNT_REQUEST, getGroupWiseAccountsCount);
}
